import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { of, Observable } from 'rxjs';

import { FacebookConversionInfo } from '../interfaces/facebook-conversion-info';
// import { HubSpotDealInfo } from '../interfaces/hub-spot-deal-info';
// import { HubSpotSubscriberInfo } from '../interfaces/hub-spot-subscriber-info';

import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TrackingPixelDataService {

  private urlFacebook = environment.urlWebServices + '/cwk/facebook';
  // private urlHubSpot = environment.urlWebServices + '/cwk/hub-spot';

  constructor(private http: HttpClient) { }

  // Create a new subscriber
  /*createSubscriber(payload: HubSpotSubscriberInfo): Observable<any> {

    return this.http.post(`${this.urlHubSpot}/subscriber`, payload)
      .pipe(
        catchError(error => observableThrowError(error.message || error))
      );
  }*/

  // Track the deal
  /*trackDeal(payload: HubSpotDealInfo): Observable<any> {

    return this.http.post(`${this.urlHubSpot}/deal`, payload)
      .pipe(
        catchError(error => observableThrowError(error.message || error))
      );
  }*/

  // Track the Facebook conversion
  trackFacebookConversion(payload: FacebookConversionInfo): Observable<any> {

    // For non-CwK projects, return empty observable
    if (environment.project !== 'cwk') {
      return of({});
    }

    return this.http.post(`${this.urlFacebook}/conversion-event`, payload);
  }
}
